import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=fc55c1b4&"
import script from "./Description.vue?vue&type=script&lang=js&"
export * from "./Description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc55c1b4')) {
      api.createRecord('fc55c1b4', component.options)
    } else {
      api.reload('fc55c1b4', component.options)
    }
    module.hot.accept("./Description.vue?vue&type=template&id=fc55c1b4&", function () {
      api.rerender('fc55c1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/integration/msteams/components/Description.vue"
export default component.exports